import {
  Box,
  Button,
  TextField,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import useMediaQuery from "@mui/material/useMediaQuery";
import { generateAndExecuteMutation } from "../../../../data/Axios/DynamicService";
import { caseManagementUrl } from "../../../../config";
import Header from "../../../../components/Header";

const base_url = caseManagementUrl.uri;

const CourtEventTypeForm = (props) => {
  const { onAction } = props;
  const initialValues = {
    eventType: props.data?.eventType || "",
  };

  const validationSchema = yup.object().shape({
    eventType: yup.string().required("Event type is required"),
  });

  const isNonMobile = useMediaQuery("(min-width:600px)");
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userIdFromSession = parseInt(decodedToken.Id);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { eventType } = values;

      const mutationData = props.isEditing
        ? {
            id: props.data.id, // must not be null
            eventType,
            updatedBy: userIdFromSession,
          }
        : {
            eventType,
            createdBy: userIdFromSession,
          };

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateCourtEvent" : "createCourtEvent",
        mutationData,
        "newCaseType",
        base_url
      );

      if (response && Object.values(response)[0] != null) {
        props.onClose?.();
        if (onAction) {
          onAction();
        } else {
          props.refetchData?.();
        }

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Court event type ${props.isEditing ? "updated" : "created"} successfully.`,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: "Server did not return expected data. Please check API response.",
        });
      }
    } catch (error) {
      console.error("Court event type creation/update error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text:
          "An error occurred while processing your request. Please try again later.",
      });
    }
    setSubmitting(false);
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Court Event Type" : "Create Court Event Type"}
        subtitle={props.isEditing ? "Edit an existing court event type" : "Create a new court event type"}
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              {/* Event Type */}
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Event Type"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.eventType}
                name="eventType"
                error={touched.eventType && !!errors.eventType}
                helperText={touched.eventType && errors.eventType}
                sx={{ gridColumn: "span 4" }}
              />
            </Box>

            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default CourtEventTypeForm;